import { useEffect } from "react";
import { useNavigationStore } from "./useNavigationStore";
import { useGlobalSearchParams, usePathname, useSegments } from "expo-router";
import { setActiveImageGroup, pathnameToKey } from "@utils/imageRequestGroups";

const NavigationListener = () => {
  const pathname = usePathname();
  const segments = useSegments();
  const globalParams = useGlobalSearchParams();

  useEffect(() => {
    useNavigationStore.getState().onPathnameChange(pathname);
    useNavigationStore.getState().onSegmentsChange(segments);
    useNavigationStore.getState().onParamsChange(globalParams);
    setActiveImageGroup(pathnameToKey(pathname));
  }, [pathname, segments, globalParams]);

  return null;
};

export default NavigationListener;
